import React from "react";

/**
 * Pre-rendered logo sizes (LANCZOS + UnsharpMask) live in /public.
 * We pick the smallest asset that still oversamples 2× the display height
 * for retina-crisp rendering — no browser-side downscale blur.
 */

const BASE = process.env.PUBLIC_URL || "";
const LOGO_SRC = {
  small: `${BASE}/logo-240.png`,   // mobile header
  medium: `${BASE}/logo-400.png`,  // sidebar / inline
  large: `${BASE}/logo-560.png`,   // login hero
};

const CRISP = { imageRendering: "-webkit-optimize-contrast" };

const VARIANTS = {
  /** Dark backgrounds — logo black bg matches ink / gradient hero */
  onDark: {
    img: "h-[5.5rem] w-auto max-w-[260px] object-contain",
    w: 260,
    h: 88,
    src: LOGO_SRC.large,
  },
  /** Centered on dark (mobile login hero) */
  onDarkCenter: {
    img: "h-[5.5rem] w-auto max-w-[260px] object-contain mx-auto",
    w: 260,
    h: 88,
    src: LOGO_SRC.large,
  },
  /** Desktop sidebar */
  sidebar: {
    img: "h-14 w-auto max-w-[200px] object-contain object-left",
    w: 200,
    h: 56,
    src: LOGO_SRC.medium,
  },
  /** Collapsed desktop sidebar — compact mark */
  sidebarCollapsed: {
    img: "h-9 w-9 object-cover object-center rounded-md",
    w: 36,
    h: 36,
    src: LOGO_SRC.small,
  },
  /** Mobile app bar — logo file already has rounded black bg; no extra frame */
  header: {
    img: "h-10 w-auto max-w-[120px] object-contain shrink-0 rounded-md",
    w: 120,
    h: 40,
    src: LOGO_SRC.small,
  },
  /** Light backgrounds */
  inline: {
    img: "h-14 w-auto max-w-[200px] object-contain",
    w: 200,
    h: 56,
    src: LOGO_SRC.medium,
  },
};

export default function BrandLogo({ variant = "inline", className = "", alt = "Bansal Cereal Products LLP", ...props }) {
  const styles = VARIANTS[variant] || VARIANTS.inline;
  return (
    <img
      src={styles.src}
      alt={alt}
      width={styles.w}
      height={styles.h}
      decoding="sync"
      loading="eager"
      draggable={false}
      style={CRISP}
      className={`${styles.img} ${className}`.trim()}
      {...props}
    />
  );
}
